import { getStore } from "app/store/store"
import { environmentsRPO } from "environments/repository"
import { IEnvironment } from "../model"

export function getEnvironmentById(environmentId: number): IEnvironment {
  const environment = getStore().getState().environments.environmentById[environmentId]
  if (!environment) {
    throw Error(`Environment id="${environmentId}" not found`)
  }
  return environment
}

export const getEnvironmentsByIds = (ids: number[]): Promise<IEnvironment[]> => environmentsRPO.getEnvironmentsById(ids)

export function getEnvironmentNameFromId(environmentId: number): string {
  const environment = getStore().getState().environments.environmentById[environmentId]
  return environment ? environment.name : ""
}

export function getEnvironmentList(): IEnvironment[] {
  return getStore().getState().environments.list
}

export function getEnvironmentTree(): IEnvironment[] {
  return getStore().getState().environments.tree
}

// @recursive
export function getAllEnvironmentChildrenIds(environment: IEnvironment): number[] {
  // @recursivity
  return environment.children.map(child => [child.id, ...getAllEnvironmentChildrenIds(child)]).flat()
}
